$(function () {
    if ($(".primaryCountryElement").length > 0) {
        $(".primaryCountryElement").each(function() {
            changeStateInput($(this), true);
        });
    }

    if ($(".secondaryCountryElement").length > 0) {
        $(".secondaryCountryElement").each(function () {
            changeStateInput($(this), true);
        });
    }

    $(".usePrimaryForSecondary").click(function () {
        if ($(this).attr("checked") == "checked") {
            $(".secondaryCountryElement").val($(".primaryCountryElement").val());
            $(".secondaryAddress").find(".stateProvinceRegionText").val($(".primaryAddress").find(".stateProvinceRegionText").val()).attr('selected', true);
            $(".secondaryAddress").find(".stateProvinceRegionDropDownUS").val($(".primaryAddress").find(".stateProvinceRegionDropDownUS").val()).attr('selected', true);
            $(".secondaryAddress").find(".stateProvinceRegionDropDownCA").val($(".primaryAddress").find(".stateProvinceRegionDropDownCA").val()).attr('selected', true);
        }

        changeStateInput($(".primaryCountryElement"), false);
        changeStateInput($(".secondaryCountryElement"), false);
        //$('.countryDropDown').change();
    });

    $(".countryDropDown").change(function () {
        changeStateInput($(this), true);
    });
    
    $(".stateProvinceRegionDropDownUS").change(function () {
        $(this).parents(".primaryAddress, .secondaryAddress").find(".stateProvinceRegionText").val($(this).val());
    });
    
    $(".stateProvinceRegionDropDownCA").change(function () {
        $(this).parents(".primaryAddress, .secondaryAddress").find(".stateProvinceRegionText").val($(this).val());
    });
});

function changeStateInput(thisCountry, changeValue) {
    var thisStateText = $(thisCountry).parents(".primaryAddress, .secondaryAddress").find(".stateProvinceRegionText");
    var thisStateDropDownUS = $(thisCountry).parents(".primaryAddress, .secondaryAddress").find(".stateProvinceRegionDropDownUS");
    var thisStateDropDownCA = $(thisCountry).parents(".primaryAddress, .secondaryAddress").find(".stateProvinceRegionDropDownCA");

    if ($(thisCountry).val().toUpperCase() == "US") {
        if (changeValue) {
            $(thisStateText).val($(thisStateDropDownUS).val());
        }
        $(thisStateText).hide();
        $(thisStateDropDownUS).show();
        $(thisStateDropDownCA).hide();
    }
    else {
        if ($(thisCountry).val().toUpperCase() == "CA") {
            if (changeValue) {
                $(thisStateText).val($(thisStateDropDownCA).val());
            }
            $(thisStateText).hide();
            $(thisStateDropDownCA).show();
            $(thisStateDropDownUS).hide();
        }
        else {
            if (changeValue) {
                $(thisStateText).val("");
            }
            $(thisStateText).show();
            $(thisStateDropDownUS).hide();
            $(thisStateDropDownCA).hide();
        }
    }
}